import { Select as FSelect } from '@forest/forms';
import { connect, mapProps, mapReadPretty } from '@formily/react';
import { PreviewText } from '../PreviewText';
export const Select = connect(FSelect, mapProps({
    dataSource: 'options',
}), mapReadPretty(PreviewText.Select));
export default Select;
